<section id="forgot-password">
    <h4><u>Change Password:</u></h4>
    <p class="errormsg">{{errormsg}}</p>
    <p class="msg">{{msg}}</p>

    <table>
        <tr>
            <td><label>New Password: </label></td>
            <td><input type="password" class="input" required id="password" [(ngModel)]="password"
                    autocomplete="new-password"></td>
        </tr>
        <tr>
            <td><label>Confirm Password: </label></td>
            <td><input type="password" class="input" required id="confirmPassword" [(ngModel)]="confirmPassword"
                    autocomplete="new-password"></td>
        </tr>
        <tr>
            <td></td>
            <td style="text-align: right;"><button id="updateButton" [disabled]="!password || !confirmPassword" (click)="changePassword()">Change
                    Password</button></td>
        </tr>
    </table>

</section>